<template>
  <div>
    <Form
      :form="form"
      :rules="validatorRules"
      :model="form"
      style="max-width: 500px; margin: 40px auto 0;"
    >
      <form-item label="账号名" props="accountName">
        <i-input type="text" :style="{width:'310px'}" autocomplete="false" :value="accountName" disabled></i-input>
      </form-item>
      <form-item label="新密码" class="stepFormText" props="password">
        <i-input :style="{width:'310px'}" v-model="form.password" type="password" autocomplete="false"></i-input>
      </form-item>
      <form-item label="确认密码" class="stepFormText" props="confirmPassword">
        <i-input :style="{width:'310px'}" v-model="form.confirmPassword" type="password" autocomplete="false"></i-input>
      </form-item>
      <form-item>
        <a class="submit" style="margin-left: 8px" @click="prevStep">上一步</a>
        <a
          class="submit"
          :loading="loading"
          type="primary"
          @click="nextStep"
          style="margin-left:20px"
        >提交</a>
      </form-item>
    </Form>
  </div>
</template>

<script>
import request from "@/api/axios";

export default {
  name: "Step3",
  //    components: {
  //      Result
  //    },
  props: ["userList"],
  data() {
    return {
      loading: false,
      form: {
        accountName: "",
        password: "",
        confirmPassword: "",
      },
      accountName: this.userList.username,
      validatorRules: {
        username: { rules: [{ required: true, message: "用户名不能为空!" }] },
        password: {
          rules: [
            {
              required: true,
              pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,}$/,
              message: "密码由8位数字、大小写字母和特殊符号组成!!",
            },
            { validator: this.handlePasswordLevel },
          ],
        },
        confirmPassword: {
          rules: [
            { required: true, message: "密码不能为空!" },
            { validator: this.handlePasswordCheck },
          ],
        },
      },
    };
  },
  methods: {
    nextStep() {
      let that = this;
      that.loading = true;
      // this.form.validateFields((err, values) => {
      //   if ( !err ){
      if (that.form.password != that.form.confirmPassword) {
        this.$Message.info("两次密码输入不一致");
        return;
      }
      var params = {};
      params.username = this.userList.username;
      params.password = that.form.password;
      params.smscode = this.userList.smscode;
      params.phone = this.userList.phone;
      request({
        url: "/api/sys/user/passwordChange",
        method: "get",
        params: params,
      }).then((res) => {
        that.loading = false;
        if (res.success) {
          var userList = {
            username: this.userList.username,
          };
          console.log(userList);
          setTimeout(function () {
            that.$emit("nextStep", userList);
          }, 1500);
        } else {
          this.passwordFailed(res.message);
          that.loading = false;
        }
        // })
        // } else{

        // }
      });
    },
    prevStep() {
      this.$emit("prevStep", this.userList);
    },

    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue("password");
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      callback();
    },
    passwordFailed(err) {
      this.$Message.info(err);
    },
  },
};
</script>
<style lang="scss" scoped>
// .stepFormText {
//   margin-bottom: 24px;
// }

// .ant-form-item-label,
// .ant-form-item-control {
//   line-height: 22px;
// }
.submit {
  height: 45px;
  line-height: 45px;
  background: rgba(0, 193, 222, 1);
  width: 45%;
  display: inline-block;
  color: #fff;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Step3.vue